import http from '../httpService';

const ParametersService = {
  getParameterService: params => http.get('parameters', { params }),
};

export default ParametersService;
